module.exports = __webpack_public_path__ + "static/plumber-making2-2982e53b2527af2ae3e618b06ebad48f.png";